import * as React from "react";

const SendNowPopover = (
  <div className="send-verion-now-popover">
    <p>
      Selecting this option will result in a file being sent to your endpoints
      as soon <br />
      as the report is saved. The file will contain the latest available data
      for your <br />
      selected reporting period.
    </p>
  </div>
);

export default SendNowPopover;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/ReportReview/SendNowPopover.tsx